/**
 * Where "Contact OMC support" goes: OMC's public contact route. The sign-in page
 * (help signing in, users without an OMCi account) and the Launch Pad's empty
 * state both link here; there is no public self-registration.
 */
export const OMC_SUPPORT_CONTACT_URL = "https://omcinternational.com/contact-omc/";
